import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { createUser, createAdmin } from '../api';
import { useNavigate } from 'react-router-dom';
import bcrypt from 'bcryptjs';
function Signup() {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        netID: '',
        email: '',
        password: '',
        major:'',
        gradStatus: '',
        gradYear: ''
    });


    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.firstName || !formData.lastName || !formData.email || !formData.netID || !formData.password|| !formData.major || !formData.gradStatus || !formData.gradYear) {
            alert('Please fill in all fields.');
            return;
        }
        const hashedPassword = await bcrypt.hash(formData.password, 10); // 10 is the number of salt rounds
        formData.password = hashedPassword;
        formData.email = formData.email.trim();
        formData.netID = formData.netID.trim();
        formData.firstName = formData.firstName.trim();
        formData.lastName = formData.lastName.trim();


        const response = await createUser(formData);
        if (response.status===200)
        {
            alert('User created successfully!');
            navigate('/login');
        } else{
            alert('Failed to create user. Please try again.');
        }
    };

    return (
        <div className="swe-backdrop h-auto min-h-screen justify-center items-center py-10">
            <div className="swe-user-card max-w-md h-fit">
                <Link to="/">
                <img src="imgs/swe_logo/SWE_Logo_Rutgers_University_4C.png" alt="SWE Logo" className="mb-10 w-20" />
                </Link>
                <h1 className="text-3xl font-semibold mb-10 text-swe-purple text-center">Let's get you started.</h1>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">First Name</label>
                        <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleChange} className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">Last Name</label>
                        <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleChange} className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
                        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="netID" className="block text-sm font-medium text-gray-700">NetID</label>
                        <input type="text" id="netID" name="netID" value={formData.netID} onChange={handleChange} className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="major" className="block text-sm font-medium text-gray-700">Major</label>
                        <select id="major" name="major" value={formData.major} onChange={handleChange} className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                            <option selected ="true">Choose a major</option>
                            <option value="Mechanical Engineering">Mechanical Engineering</option>
                            <option value="Aerospace Engineering">Aerospace Engineering</option>
                            <option value="Biomedical Engineering">Biomedical Engineering</option>
                            <option value="Chemical Engineering">Chemical Engineering</option>
                            <option value="Civil Engineering">Civil Engineering</option>
                            <option value="ECE Engineering">Electrical and Computer Engineering</option>
                            <option value="Environmental Engineering">Environmental Engineering</option>
                            <option value="Industrial Engineering">Industrial Engineering</option>
                            <option value="Pacaking Engineering">Packaging Engineering</option>
                            <option value="Computer Science">Computer Science</option>
                            <option value="ITI">ITI</option>
                            <option value="Other">Other</option>
                        </select>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="gradStatus" className="block text-sm font-medium text-gray-700">Grad Status</label>
                        <select id="gradStatus" name="gradStatus" value={formData.gradStatus} onChange={handleChange} className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                            <option selected ="true">Choose Grad Status</option>
                            <option value="Undergrad">Undergraduate</option>
                            <option value="Grad">Graduate</option>
                        </select>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="gradYear" className="block text-sm font-medium text-gray-700">Graduation Date</label>
                        <input type="number" id="gradYear" name="gradYear" value={formData.gradYear} onChange={handleChange} className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                    </div>

                    <div className="mb-4">
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
                        <input type="password" id="password" name="password" value={formData.password} onChange={handleChange} className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                    </div>
                    <button type="submit" className="swe-btn w-full py-2 px-4 font-medium center">Sign Up</button>
                </form>
                <p className="mt-4 text-md text-gray-600">Already have an account? <Link to="/login" className="text-swe-purplelight hover:text-swe-red">Log in</Link></p>
            </div>
        </div>
    );
}

export default Signup;
